import { getRoot } from "mobx-state-tree";

export const supportMessagesStoreViews = self => ({
  get token() {
    return getRoot(self).authStore.token;
  }
});
